import template from './homeowner-warning.jade';

export default function () {
  return {
    template,
    scope: {},
    bindToController: {
      ad: '=',
    },
    controller: () => {},
    controllerAs: 'homeownerWarning',
    replace: true,
  };
}
